module.exports = __webpack_public_path__ + "img/floracion.f70568dd.png";